import * as React from 'react';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/AddCircle';
import { UserPlus, Eraser  } from 'lucide-react';

const Boton = styled(Button)(({ props }) => ({
  margin: 10,
  marginLeft: props.isMobile ? "20%":"",
  width: props.isMobile ? "200px":"",
  textDecoration: 'none',
  backgroundColor: props.convocatoria ? "#EE805D" : props.bonificados ? "#003c66" : "rgba(0, 60, 102, 0.8)",
  color: "white",
  transition: "background-color 0.3s, color 0.3s",
  border: `1px solid`,
  '&:hover': {
    color: props.convocatoria ? "#EE805D" : props.bonificados? "#003c66" : "rgba(0, 177, 195, 0.8);",
    backgroundColor: (props.convocatoria || props.bonificados) ? "white" : "WHITE",
    border: props.convocatoria ? "#EE805D" : props.bonificados ? "#003c66" : "rgba(0, 177, 195, 0.8);",
    border: `1px solid`
  },
}));

export default function UploadLinkButton(props) {
  
  if(props.icono && !props.texto){
    return (
      <Button
      startIcon={<Eraser/>}
      component={Link} 
      to={props.to} 
      sx={{
        scale: '1.4',
        color: 'rgba(0, 60, 102, 0.8)',
        justifyContent: 'center',
        marginLeft: '10px',
        minWidth: '20px',
        '&:hover': {
        backgroundColor: 'transparent'
        },
        transition: 'none'
      }}
      >
      </Button>
    );
  }

  if(props.icono === 'addPersona' && props.texto === 'Crear Persona'){
    return (
      <Boton
      props={props}
      variant="contained"
      startIcon={<UserPlus />}
      component={Link} 
      to={props.to} 
    >
     {props.texto}
    </Boton>
  );
  }

  return (
    <Boton
      props={props}
      variant="contained"
      startIcon={<SaveIcon />}
      component={Link} 
      to={props.to} 
    >
      {props.texto}
    </Boton>
  );
}
